export default __webpack_public_path__ + "pgnv-assets/e7189439f73760930360521b47b72677.png";